import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Product.css'
import { BsArrowRight } from 'react-icons/bs';

const Product = ({ product }) => {
    const { _id, name, img, description, price, quantity, supplierName
    } = product;

    const navigate = useNavigate();
    const navigateToInventory = id => {
        navigate(`/inventory/${id}`)
    }

    return (
        <div className="col">
            <div
             data-aos="zoom-out-up"
            data-aos-easing="linear"
            data-aos-duration="1500"
             className="card h-100 text-center text-white product-card pt-2">
                <img style={{width: '120px'}} src={img} className="card-img-top mt-3 product-pic mx-auto" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{name}</h5>
                    <p style={{ color: '#94A3B8' }} className="card-text pb-2">{description}</p>
                        <h4 style={{ marginTop: '-22px', fontWeight: '700' }}>{price} TK</h4>
                        <p style={{ marginTop: '-5px', marginBottom: '5px',color: '#94A3B8'  }}>Quantity: {quantity}</p>

                    <button className='update-btn' onClick={() => navigateToInventory(_id)}>Update <BsArrowRight></BsArrowRight></button>
                </div>
            </div>
        </div>
    );
};

export default Product;